module.exports = __webpack_public_path__ + "static/img/iphone-ad.8461686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone-ad.png
// module id = 6SJo
// module chunks = 1